module.exports = ".d-flex-sp-ar{display:flex;justify-content:space-between;width:100%;align-items:center}\n"